import { render, staticRenderFns } from "./loginRegister.vue?vue&type=template&id=459f4639&scoped=true"
import script from "./loginRegister.vue?vue&type=script&lang=js"
export * from "./loginRegister.vue?vue&type=script&lang=js"
import style0 from "./loginRegister.vue?vue&type=style&index=0&id=459f4639&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459f4639",
  null
  
)

export default component.exports